import { app } from '../../../../app';
import { Controller } from './shared-accounts.controller';

app.component('companySharingCenterSharedAccounts', {
    bindings: {accounts: '<'},
    controller: Controller,
    templateUrl: require('./shared-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-accounts/shared-accounts.component.js